<template>
<div>
    <div>
        <vs-alert v-if="ifQuestionOpen" color="danger" class="mt-3">
            <p class="text-center"><i class="fa-solid fa-triangle-exclamation"></i> Pendiente calificar la pregunta abierta</p>
        </vs-alert>
        <p class="color1 text-2xl text-center mt-3">Desafío de {{ObjectEvaluacion.estudiante}} - {{intentoSelected.intento}}</p>
        <vs-divider></vs-divider>
        <vs-row>
            <vs-col vs-w="6" vs-xs="12">
                <p class="mt-3"><b class="color1">Fecha inicio: </b> {{ intentoSelected.fecha_comienza }} - {{ intentoSelected.fecha_finaliza }}</p>
                <p class="mt-5 color2 tamanio1">
                    <b>Comentario del Profesor/a:</b> {{ setEvaluacion.indicaciones }}
                </p>
            </vs-col>
            <vs-col vs-w="6" vs-xs="12">
                <div class="mt-2 mb-3 text-right">
                    <p class="mr-3"><b class="color1">Calificación: </b> </p><br>
                    <h2 class="mr-4 ">
                        <span class="bg-calificacion mr-2">
                            {{intentoSelected.calificacion }} / {{ setEvaluacion.puntaje }}
                        </span>
                    </h2>
                    <!-- <span><b class="color1">Límite de tiempo: </b> {{ setEvaluacion.tiempo }} minutos</span> -->
                </div>
            </vs-col>
        </vs-row>

        <vs-divider class="mt-3"></vs-divider>
        <div class="vx-row">
            <div class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-full mb-6">
                <div class="vx-row" v-for="(item,key) in arrayQuestions" :key="key">
                    <div class="vx-col w-full mb-6 m-4">
                        <div class="flex bg1" style="justify-content: space-between;">
                            <p class="bg1 titulo">Pregunta {{ key + 1 }} <small style="font-size: 10px;" v-if="item.id_tipo == idPreguntaMultiple">( Puede aver varias opciones de respuesta )</small></p>
                            <p class="bg1 titulo">{{ item.puntajeOpcion }} / {{ item.puntaje }} pts</p>
                        </div>
                        <p class="mt-5">{{ item.pregunta }}</p>
                        <!--imagen-->
                        <img v-if="item.url!='' && item.url!='null' && item.url!=null" :src="$data_book+'archivos/'+'preguntas'+'/'+item.url" class="img-responsive mt-5" width="200" height="200" style="border-radius: 5px;">
                        <!--opciones-->
                        <br>
                        <vs-divider></vs-divider>
                        <!--pregunta abierta-->
                        <div v-if="item.id_tipo == idPreguntaAbierta">
                            <!--INPUT-->
                            <div class="flex">
                                <div class="vx-row" style="width: 100%;">
                                    <div class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-5/6 mb-6">
                                        <div v-if="item.respuestas.length > 0">
                                            <vs-input disabled v-model="item.respuestas[0].respuesta" class="w-full" label="Respuesta" placeholder="Escribe tu respuesta aquí"></vs-input>
                                        </div>
                                    </div>
                                    <div class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-1/6 mb-6" v-if="usuario.id_group == 6">
                                        <vs-input-number min="0" @input="validateNumber" :max="puntajeAbierta" v-model="calificacionAbierta" style="margin-top:25px;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--pregunta columna-->
                        <div v-else-if="item.id_tipo == idPreguntaColumna">
                            <table style="width: 100%;" class="ml-3" v-if="item.respuestas.length > 0">
                                <tr>
                                    <th>{{ item.columna1 }}</th>
                                    <th >{{ item.columna2 }}</th>
                                    <th>Calificación</th>
                                    <th></th>
                                </tr>
                                <tr v-for="(tr, indexitem) in item.respuestas[0].respuesta" :key="indexitem" >
                                    <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                    <td>
                                        {{ tr.seleccionar }}
                                    </td>
                                    <td>
                                        {{ tr.calificacion }}
                                    </td>
                                    <td>
                                        <span style="font-size:25px;" class="text-success" v-if="tr.calificacion > 0"><i class="fa-regular fa-circle-check"></i></span>
                                        <span style="font-size:25px;" class="text-danger" v-else><i class="fa-regular fa-circle-xmark"></i></span>
                                    </td>
                                </tr>
                            </table>
                            <!--en el caso que no este el array item.respuestas colocar en cero la califiacion-->
                            <table style="width: 100%;" v-else>
                                <tr>
                                    <th>{{ item.columna1 }}</th>
                                    <th >{{ item.columna2 }}</th>
                                    <th>Calificación</th>
                                    <th></th>
                                </tr>
                                <tr v-for="(tr, indexitem) in item.opciones" :key="indexitem" >
                                    <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                    <td>
                                    </td>
                                    <td>
                                        0
                                    </td>
                                    <td>
                                        <span style="font-size:25px;" class="text-danger"><i class="fa-regular fa-circle-xmark"></i></span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!--pregunta multiple-->
                        <div v-else-if="item.id_tipo == idPreguntaMultiple">
                            <div v-if="item.respuestas.length > 0">
                                <ul class="leftx" v-for="(tr,key2) in item.respuestas[0].respuesta" :key="key2">
                                    <li class="my-2">
                                        <div class="flex" style="justify-content: space-between;">
                                            <div>
                                                <vs-checkbox disabled v-model="tr.seleccionar" color="success">{{ tr.respuesta }}</vs-checkbox>
                                            </div>
                                            <div>
                                                <span class="mr-3 font-semibold">{{ tr.calificacion }}</span>
                                                <span style="font-size:25px;" class="text-success" v-if="tr.calificacion > 0"><i class="fa-regular fa-circle-check"></i></span>
                                                <span style="font-size:25px;" class="text-danger" v-else><i class="fa-regular fa-circle-xmark"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                    <li class="my-2">
                                        <div class="flex" style="justify-content: space-between;">
                                            <div>
                                                <vs-checkbox disabled v-model="item.seleccionar" color="success">{{ tr.respuesta }}</vs-checkbox>
                                            </div>
                                            <div>
                                                <span style="font-size:25px;" class="text-danger"><i class="fa-regular fa-circle-xmark"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--preguntas normales-->
                        <div v-else>
                            <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                <li class="my-2">
                                    <div class="flex" style="justify-content: space-between;">
                                        <div>
                                            <vs-checkbox disabled v-model="tr.seleccionado" color="success">{{ tr.respuesta }}</vs-checkbox>
                                        </div>
                                        <div>
                                            <span style="font-size:25px;" class="text-success" v-if="tr.opcion == 'true'"><i class="fa-regular fa-circle-check"></i></span>
                                            <span style="font-size:25px;" class="text-danger" v-else><i class="fa-regular fa-circle-xmark"></i></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <vs-divider></vs-divider>
                <!--boton de finalizar evaluacion-->
                <vs-button @click="finalizarEvaluacion()" v-if="puntajeAbierta > 0 && usuario.id_group == 6" class="w-full mt-5" type="gradient" color="success">Guardar Evaluación</vs-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    data() {
        return {
            usuario:[],
            idPreguntaMultiple: 8,
            idPreguntaAbierta: 7,
            idPreguntaColumna: 5,
            arrayQuestions: [],
            fecha: '',
            ifQuestionOpen: false,
            calificacionAbierta: 0,
            puntajeAbierta: 0,
            datosPreguntaAbierta: '',
        }
    },
    props: {
        arrayPreguntas: {
            type: Array,
            default: () => ([])
        },
        evaluacionEstudiante: {
            type: Object,
            default: () => ({})
        },
        setEvaluacion: {
            type: Object,
            default: () => ({})
        },
        ObjectEvaluacion: {
            type: Object,
            default: () => ({})
        },
        intentoSelected: {
            type: Object,
            default: () => ({})
        }
    },
    created(){
        let me = this
        me.usuario = JSON.parse(localStorage.getItem('usuario'))[0]
    },
    mounted() {
        let me = this
        me.start()
    },
    methods: {
        start() {
            let me = this
            me.ifQuestionOpen = false
            me.datosPreguntaAbierta = ''
            me.puntajeAbierta = 0
            me.arrayQuestions = me.arrayPreguntas
            //validar si hay una pregunta abierta sin calificar
            me.arrayQuestions.forEach(item => {
                if (item.id_tipo == me.idPreguntaAbierta) {
                    me.puntajeAbierta = item.puntaje
                    if (item.respuestas.length > 0) {
                        me.datosPreguntaAbierta = item.respuestas[0]
                        me.calificacionAbierta = item.respuestas[0].puntaje
                        if (item.respuestas[0].puntaje == 0) {
                            me.ifQuestionOpen = true
                        } else {
                            me.ifQuestionOpen = false
                        }
                    }
                }
            })
            //de las opciones de las preguntas voy a validar con cada array de respuestas de cada pregunta
            me.arrayQuestions.forEach(item => {
                let respuestas = item.respuestas
                if (respuestas.length > 0) {
                    let id_respuesta = respuestas[0].respuesta
                    item.opciones.forEach(tr => {
                        //si el id_pregunta de la respuesta es igual al id_pregunta de la pregunta coloco true
                        if (tr.id == id_respuesta) {
                            tr.seleccionado = true
                        } else {
                            tr.seleccionado = false
                        }
                    })
                    item.puntajeOpcion = respuestas[0].puntaje
                } else {
                    item.opciones.forEach(tr => {
                        tr.seleccionado = false
                    })
                    item.puntajeOpcion = 0
                }
            })
        },
        validateNumber() {
            let me = this
            if (me.calificacionAbierta > me.puntajeAbierta) {
                me.calificacionAbierta = me.puntajeAbierta
            }
            if (me.calificacionAbierta < 0) {
                me.calificacionAbierta = 0
            }
        },
        finalizarEvaluacion() {
            let me = this
            console.log("ee",me.datosPreguntaAbierta)
            if (me.datosPreguntaAbierta.id_pregunta == '' || me.datosPreguntaAbierta.id_pregunta == null || me.datosPreguntaAbierta.id_pregunta == undefined) {
                me.$vs.notify({
                    title: 'Error',
                    text: 'Error al finalizar la evaluación',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
                return

            }
            let formData = new FormData();
            //preguntas abiertas
            formData.append('id_evaluacion', this.intentoSelected.id_evaluacion);
            formData.append('id_intento', this.intentoSelected.id_evaluacion_estudiante);
            formData.append('id_estudiante', this.intentoSelected.id_estudiante);
            formData.append('calificacion', me.calificacionAbierta)
            formData.append('calificarPreguntaAbierta', '1')
            formData.append('id_pregunta', this.datosPreguntaAbierta.id_pregunta)
            formData.append('respuesta', this.datosPreguntaAbierta.respuesta)
            me.$vs.loading()
            this.$http.post(this.$server_url + 'evaluacionEstudiante', formData)
                .then(res => {
                    this.$vs.loading.close()
                    if (res.data.status == 0) {
                        this.$vs.notify({
                            title: 'Error',
                            text: res.data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                        return
                    }
                    if (res.data.status == 500) {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Error al finalizar la evaluación',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                        return
                    }
                    me.f_notificaciones(res.data.message, "success");
                    me.$emit('changeHandle', true)
                })
                .catch(err => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Error al finalizar la evaluación',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                })
        },
    }
}
</script>

<style scoped>
.color1 {
    color: #2F68AD;
}

.titulo {
    font-size: 18px;
    color: #19467c;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
}

.tamanio1 {
    font-size: 11px;
}

.bg1 {
    background: #f1f2f3;
    padding: 8px;
}

.reloj {
    font-size: 16px;
    color: #2F68AD;
    text-shadow: #e3e5e7 1px 1px 1px;
    padding: 5px;
}
.bg-calificacion{
    background-color:  rgba(var(--vs-white1), 1) !important;
    border-radius: 10px;
    padding: 8px 6px;
    /* background-color: red */
}
</style>
